/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=4b7794ee&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=4b7794ee&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "F:\\php-project\\admin_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7794ee"],['__file',"library/components/VabLogo/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b7794ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b7794ee', __exports__)) {
    api.reload('4b7794ee', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4b7794ee&scoped=true", () => {
    api.rerender('4b7794ee', render)
  })

}


export default __exports__